import React from 'react';
import { Grid, Divider } from '@material-ui/core';
import Utils from '../../providers/Utils';


export default class TasksAngajatView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }


    utils = new Utils()


    openTaskEdit = (t) =>{

        console.log('t :>> ', t);
        console.log('this.props.listEtape :>> ', this.props.listEtape);

        let idx = this.props.listEtape.findIndex(i => i.id === t.id_etapa_proiect)

        if(idx !== -1){
            this.props.editTask(t,this.props.listEtape[idx] )
        }
    }


    render() {
        return (
            <div>
                <Grid container style={{

                    padding: 20
                }}>
                    {this.props.list.map((l, idx) => {

                        return (

                            < Grid style={{ marginTop: 20 }} key={`data${idx}`
                            } item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <h3 style={{ marginBottom: 20, width: 'fit-content', fontSize: 16,  }} >{l.title}
                                    <i onClick={() => { this.props.showTasks(l.id) }} style={{ verticalAlign: 'middle', cursor: 'pointer' }} className='material-icons'>{l.show_tasks ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}</i></h3>
                                
                                {!l.show_tasks && 
                                    <Divider style={{width:'100%'}}/>
                                }
                                {l.show_tasks &&
                                    <table style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        tableLayout: 'auto',
                                        textAlign: 'left'
                                    }}>
                                        {/* <thead>
                                        <tr style={{ borderBottom: '1px solid gray', fontSize: 12, lineHeight: '34px' }}>

                                            <th style={{ color: '#b3b3b3' }} >Denumire Task</th>
                                            <th style={{ color: '#b3b3b3' }} >Data Inceput</th>
                                            <th style={{ color: '#b3b3b3' }}>Data Sfarsit</th>
                                            <th style={{ color: '#b3b3b3' }}>Responsabil</th>


                                        </tr>
                                    </thead> */}

                                        <tbody>
                                            {l.tasks.map((t, idx2) => {

                                                return (
                                                    <tr  key={'t' + idx2} style={{ borderBottom: '1px solid gray', fontSize: 12, lineHeight: '34px' }}>
                                                        <td>
                                                            <i onClick={()=>{this.props.finalizeazaTask(t)}} style={{
                                                                verticalAlign: 'middle',
                                                                marginRight: 10,
                                                                fontSize: 20,
                                                                cursor:'pointer',
                                                                color:t.statusul === 'Finalizat'  ? 'green' : 'black'
                                                            }} className='material-icons'>check_circle_outline</i>
                                                            <span style={{cursor:'pointer', display: 'block'}} onClick={()=>{this.openTaskEdit(t)}}>{t.titlu}</span>
                                                            {/* {t.titlu} */}

                                                        </td>
                                                        <td onClick={()=>{this.openTaskEdit(t)}}  style={{ position: 'relative', cursor: 'pointer' }} >

                                                            <span>{t.nume_proiect}</span>
                                                        </td>
                                                        <td style={{ position: 'relative', cursor: 'pointer' }}>

                                                            <span>{t.nume_etapa}</span>

                                                        </td>
                                                        <td style={{
                                                            width: '20%',
                                                            textAlign: 'right'
                                                        }}>
                                                            <span
                                                            style={{color:this.utils.defaultData() > this.utils.ParseDataFromSql(t.pana_cand_data) ? 'red' :'black' }}
                                                            >{this.utils.dataPrescurtataRomana(this.utils.ParseDataFromSql(t.cand_data))}
                                                            - {this.utils.dataPrescurtataRomana(this.utils.ParseDataFromSql(t.pana_cand_data))} </span>
                                                        </td>
                                                    </tr>
                                                )

                                            })}


                                        </tbody>


                                    </table>
                                }


                            </Grid>
                        )

                    })}
                </Grid>
            </div >
        );
    }
}